import Vue from '/vodalys/vvuejs/vue'

// ## Import and configure components ###############

import VPin from './components/VPin.vue'
Vue.component('VPin', VPin)

import VChevronUpDown from './components/VChevronUpDown.vue'
Vue.component('VChevronUpDown', VChevronUpDown)


// ### Filters import ##########################
// import './filters/translate.mjs'


// ### Import and configure vue-tippy pour les popup
import VueTippy, { TippyComponent } from "vue-tippy/dist/vue-tippy.esm.js";
import './style/v17-vue-tippy.scss'



Vue.use(VueTippy, {
  directive: "tippy", // => v-tippy
  flipDuration: 0,
  allowHTML: true,
  appendTo: () => document.fullscreenElement || document.body,
  popperOptions: {
    modifiers: {
      preventOverflow: {
        enabled: true,
        rootBoundary: 'document',
      },
      hide: {
        enabled: false
      }
    }
  }
});
Vue.component("Tippy", TippyComponent);
